import React, {useState, useEffect} from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Breadcrumb, PromoCategory, BackdropCircular } from 'components';
import {
  Card,
  Tab,
  Tabs,
  LinearProgress,
  Button,
  Badge
} from '@material-ui/core';
import {
  getStoreProductsApi,
  getHomepagePromoCategoriesConfigsApi,
  updateStoreProductsByCategoryApi,
  updateStoreConfigsApi,
  saveStoreCategoryApi
} from 'api';


const HomepagePromoTabs = () => {
  const dispatch = useDispatch();

  const [tabIndex, setTabIndex] = useState(0);
  const [error, setError] = useState({
    errorTab1: false,
    errorTab2: false,
    errorTab3: false
  });

  const {
    errorTab1,
    errorTab2,
    errorTab3
  } = error;

  const isError = errorTab1 || errorTab2 || errorTab3;

  const {
    store_products,
    categories_products_to_update,
    productsLoading,
    productsError,
    updateCategoryProductsLoading
  } = useSelector((state) => state.products);
  const userStore = useSelector((state) => state.user?.profile?.stores?.[0]);
  const {
    homepageCategoriesConfigs,
    loadingHomepagePromoCategoriesConfigs,
    homeCategories
  } = useSelector((state) => state.store_configs);
  const { updatedHomepageCategories } = useSelector((state) => state.categories);
  const isPremiumStore = userStore?.storeType === 'premium' || userStore?.storeType === 'modern_premium';
  const isPremiumPlusStore = userStore?.storeType === 'premium_plus' || userStore?.storeType === 'modern_premium_plus';
  const isModernStore = userStore?.storeType === 'premium_lite';

  useEffect(() => {
    if (store_products.catalogProducts === undefined && userStore?.isCreated && !store_products.length) {
      getStoreProductsApi({dispatch});
    }

    if (homepageCategoriesConfigs.length === 0) {
      getHomepagePromoCategoriesConfigsApi({dispatch});
    }
  }, []);

  const handleTabChange = (e, value) => {
    setTabIndex(value);
  };

  const setTabTitle = (idx) => {
    const title = homepageCategoriesConfigs.find((config) => (
      config.path === `store_info/home_tabs/carousel_${idx + 1}_title`)
    )?.value;

    return error[`errorTab${idx + 1}`] ?
      <Badge badgeContent={'!'} color="error" className="pr-3">
        {title?.length ? title : <>{(isPremiumStore || isPremiumPlusStore || isModernStore) ? `Carousel ${idx + 1}` : `Tab ${idx + 1}`}</>}
      </Badge>
      :
      <>
        {title?.length ? title : <>{(isPremiumStore || isPremiumPlusStore || isModernStore) ? `Carousel ${idx + 1}` : `Tab ${idx + 1}`}</>}
      </>;
  };

  const handleSave = () => {
    if (Object.keys(categories_products_to_update).length !== 0) {
      const products = Object.values(categories_products_to_update);
      updateStoreProductsByCategoryApi({dispatch, products});
    }

    if (homepageCategoriesConfigs.length > 0) {
      updateStoreConfigsApi({dispatch, configs: homepageCategoriesConfigs});

      if (Object.keys(updatedHomepageCategories).length !== 0) {
        Object.values(updatedHomepageCategories).map((category) => {
          saveStoreCategoryApi({dispatch, category});
        });
      }
    }
  };

  return (
    <div className="flex-grow flex-column relative h-full scroll-y">
      <Breadcrumb
        routeSegments={[
          { name: 'Settings', path: '/settings#go_live_requirements' },
          { name: 'UI Configurations', path: '/settings#UI_configurations' },
          { name: 'Homepage Settings', path: '/configurations/homepage'},
          { name: `Homepage ${(isPremiumStore || isPremiumPlusStore) ? 'Carousels' : 'Categories'}`}
        ]}
      />

      <div className="m-10">
        <p>In this section you can add homepage {(isPremiumStore || isPremiumPlusStore) ? 'carousels' : 'categories'} for promotions (Bestsellers, Specials, Favorites, etc.)</p>
        <Card className="p-8">
          <Tabs
            value={tabIndex}
            onChange={handleTabChange}
            indicatorColor="primary"
            textColor="primary"
            className="mx-10"
          >
            {!loadingHomepagePromoCategoriesConfigs && homeCategories.map((item, idx) => {
              if ((isPremiumPlusStore || isModernStore) && idx >= 2) {
                return null;
              }

              return (
                <Tab
                  className="capitalize font-medium px-8"
                  value={idx}
                  key={`tab-${idx}`}
                  label={setTabTitle(idx)}
                />
              );
            })}
          </Tabs>
          {loadingHomepagePromoCategoriesConfigs && <LinearProgress className="m-10" />}
          {!productsLoading && productsError && <div>Can&apos;t fetch products data: {productsError}</div>}
          {!loadingHomepagePromoCategoriesConfigs && !productsError && homeCategories.map((item, idx) => {
            if ((isPremiumPlusStore || isModernStore) && idx >= 2) {
              return null;
            }

            return (
              tabIndex === idx && <PromoCategory categoryId={item.value} index={idx + 1} onError={setError} error={error} key={idx} />
            );
          })}
        </Card>
        <div className="flex justify-end">
          <Button
            variant="contained"
            color="primary"
            className="mt-10"
            onClick={handleSave}
            disabled={isError}
          >
            Save Configurations
          </Button>
          <BackdropCircular loading={updateCategoryProductsLoading} />
        </div>
      </div>
    </div>
  );
};

export default HomepagePromoTabs;
